const COLORED_SHAPE_TYPES = ['fl', 'st'];

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const expandShorthand = (hex: string) =>
  hex.length === 3
    ? hex
        .split('')
        .map((character) => character + character)
        .join('')
    : hex;

const hexToLottieColor = (hex: string) => {
  const value = expandShorthand(hex.replace('#', ''));
  const channel = (index: number) =>
    parseInt(value.slice(index * 2, index * 2 + 2), 16) / 255;

  return [channel(0), channel(1), channel(2), 1];
};

const isColoredShape = (node: Record<string, unknown>) =>
  COLORED_SHAPE_TYPES.includes(String(node.ty)) && isRecord(node.c);

const repaintNode = (node: unknown, color: number[]): unknown => {
  if (Array.isArray(node)) {
    return node.map((item) => repaintNode(item, color));
  }

  if (!isRecord(node)) return node;

  const repainted = Object.keys(node).reduce<Record<string, unknown>>(
    (result, key) => {
      result[key] = repaintNode(node[key], color);
      return result;
    },
    {}
  );

  if (!isColoredShape(node)) return repainted;

  return {
    ...repainted,
    c: { ...(repainted.c as Record<string, unknown>), k: color },
  };
};

export const applyLottieColor = <T>(animationData: T, hex: string): T =>
  repaintNode(animationData, hexToLottieColor(hex)) as T;
